// @ts-nocheck
import {
  AdjustResult,
  AdjustResultAbsolute,
  AdjustResultPercent,
  AloftPrice,
  mean,
  median,
} from '@aloft/toolkit-shared';

const everyResultIsAloftPrice = (results: AdjustResult[]): results is AdjustResultAbsolute[] =>
  results.every((result) => result.t === 'absolute');

const everyResultIsNumber = (results: AdjustResult[]): results is AdjustResultPercent[] =>
  results.every((result) => result.t === 'percent');

export const generateAdjustResultsSummaryStatistics = (
  results: AdjustResult[],
): { median: AdjustResult; average: AdjustResult } => {
  if (results.length === 0) {
    return {
      median: { t: 'absolute', value: AloftPrice.fromUnitAmount(0) },
      average: { t: 'absolute', value: AloftPrice.fromUnitAmount(0) },
    };
  }

  if (everyResultIsAloftPrice(results)) {
    const values = results.map((result) => result.value.unitAmount);

    return {
      average: { t: 'absolute', value: AloftPrice.fromUnitAmount(mean(values)) },
      median: { t: 'absolute', value: AloftPrice.fromUnitAmount(median(values)) },
    };
  }

  if (everyResultIsNumber(results)) {
    const values = results.map((result) => result.value);

    return {
      average: { t: 'percent', value: mean(values) },
      median: { t: 'percent', value: median(values) },
    };
  }

  throw new Error('Cannot find median or average of adjust results of different types');
};
